import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const IroningServiceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "IroningServiceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M6.44142 22C6.29146 22 6.14151 21.9428 6.0271 21.8284C5.79828 21.5996 5.79828 21.2286 6.0271 20.9998L14.8136 12.2133C15.0424 11.9845 15.4134 11.9845 15.6422 12.2133C15.871 12.4422 15.871 12.8131 15.6422 13.042L6.85574 21.8284C6.74133 21.9428 6.59138 22 6.44142 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7383 22C17.5883 22 17.4384 21.9428 17.324 21.8284L8.53751 13.042C8.30869 12.8132 8.30869 12.4422 8.53751 12.2133C8.76633 11.9845 9.13732 11.9845 9.36615 12.2133L18.1526 20.9998C18.3814 21.2286 18.3814 21.5996 18.1526 21.8284C18.0382 21.9428 17.8882 22 17.7383 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.2487 13.2136H2.67578C2.35218 13.2136 2.08984 12.9513 2.08984 12.6277V10.1172C2.08984 9.7936 2.35218 9.53127 2.67578 9.53127H20.2487C20.7405 9.53127 21.2028 9.72282 21.5505 10.0706C21.8982 10.4179 22.0899 10.8803 22.0899 11.3724C22.0899 11.8645 21.8982 12.327 21.5502 12.6746C21.2029 13.022 20.7405 13.2136 20.2487 13.2136ZM3.26171 12.0417H20.2487C20.4274 12.0417 20.5955 11.9721 20.7218 11.8457C20.8484 11.7192 20.918 11.5512 20.918 11.3724C20.918 11.1936 20.8484 11.0256 20.7221 10.8994C20.5954 10.7727 20.4274 10.7031 20.2487 10.7031H3.26172L3.26171 12.0417Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.32421 10.7031H4.55861C3.54339 10.7031 2.71744 9.8772 2.71744 8.862C2.71744 8.36997 2.90907 7.90756 3.25703 7.55995C3.60443 7.21242 4.06677 7.02088 4.55861 7.02088H8.32421C9.33943 7.02088 10.1654 7.8468 10.1654 8.86201C10.1654 9.87722 9.33943 10.7031 8.32421 10.7031ZM4.55861 8.19275C4.37987 8.19275 4.21187 8.26234 4.08554 8.38872C3.95891 8.51523 3.88932 8.68322 3.88932 8.86201C3.88932 9.23104 4.18957 9.53128 4.55861 9.53128H8.32421C8.69325 9.53128 8.9935 9.23104 8.9935 8.86201C8.9935 8.49298 8.69325 8.19276 8.32421 8.19276L4.55861 8.19275Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.69661 8.19272H3.93101C2.91579 8.19272 2.08984 7.36678 2.08984 6.35158C2.08984 5.85943 2.2815 5.397 2.6295 5.04944C2.97683 4.702 3.43917 4.51045 3.93101 4.51045H7.69661C8.71183 4.51045 9.53778 5.33637 9.53778 6.35158C9.53778 7.36679 8.71183 8.19272 7.69661 8.19272ZM3.93101 5.68233C3.75227 5.68233 3.58427 5.75192 3.45794 5.8783C3.33128 6.0048 3.26172 6.17276 3.26172 6.35159C3.26172 6.72062 3.56197 7.02086 3.93101 7.02086H7.69661C8.06565 7.02086 8.3659 6.72062 8.3659 6.35159C8.3659 5.98256 8.06565 5.68234 7.69661 5.68234L3.93101 5.68233Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.32421 5.68229H4.55861C3.54339 5.68229 2.71744 4.85637 2.71744 3.84116C2.71744 3.34909 2.90907 2.88666 3.25706 2.53906C3.60446 2.19156 4.0668 2.00001 4.55861 2.00001H8.32421C9.33943 2.00001 10.1654 2.82595 10.1654 3.84115C10.1654 4.85635 9.33943 5.68229 8.32421 5.68229ZM4.55861 3.1719C4.37988 3.1719 4.21187 3.24149 4.08554 3.36788C3.9589 3.49437 3.88932 3.66235 3.88932 3.84117C3.88932 4.2102 4.18957 4.51042 4.55861 4.51042H8.32421C8.69325 4.51042 8.9935 4.2102 8.9935 3.84117C8.9935 3.47214 8.69325 3.1719 8.32421 3.1719H4.55861Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.9935 10.7031H13.9727C13.6491 10.7031 13.3867 10.4408 13.3867 10.1172V7.75891C13.3867 6.83314 13.5664 5.93007 13.9206 5.07481C14.2749 4.21951 14.7865 3.45392 15.4412 2.79932L16.0687 2.17168C16.1786 2.06176 16.3276 2 16.483 2C16.6385 2 16.7875 2.06174 16.8974 2.17166L17.525 2.79937C18.1796 3.4539 18.6913 4.2195 19.0455 5.0748C19.3998 5.93006 19.5794 6.83312 19.5794 7.7589V10.1172C19.5794 10.4408 19.3171 10.7031 18.9935 10.7031ZM14.5586 9.53126H18.4076V7.75891C18.4076 6.98781 18.258 6.23563 17.9629 5.52327C17.6678 4.81089 17.2417 4.17322 16.6964 3.62801L16.4831 3.41466L16.2699 3.62794C15.7245 4.17322 15.2984 4.81089 15.0033 5.52327C14.7082 6.23564 14.5586 6.9878 14.5586 7.75891V9.53126Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default IroningServiceIcon;
